import { LazyQRCodeCanvas } from '@dialog-qr-code/LazyQRCodeCanvas'
import { isMobileDevice } from '@dni-utils/is-mobile-device'
import { Box } from '@pets-ui/Box/Box'
import { Button } from '@pets-ui/Button/Button'
import { HStack } from '@pets-ui/HStack/HStack'
import { PayMe } from '@pets-ui/Icons'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import { Suspense } from 'react'
import { useTranslation } from 'react-i18next'

interface PayMePaymentInfoProps {
  url: string
}

export const PayMePaymentInfo = ({ url }: PayMePaymentInfoProps) => {
  const _isMobileDevice = isMobileDevice()
  const { t } = useTranslation()
  return (
    <Box borderRadius="4px" p="12px" borderWidth="1px" borderStyle="solid" borderColor={colors.grey300}>
      <VStack gap="8px">
        <HStack gap="12px">
          <Text variant="body" color={colors.grey600} noWrap>{t('orderDetail.paymentQrCode', { defaultValue: '付款二維碼' })}</Text>
          <Box flex={1} minWidth={0}>
            <VStack alignItems="center" gap="8px">
              <Box>
                <Suspense
                  fallback={(
                    <Text variant="body" color={colors.grey600}>
                      加載中
                    </Text>
                  )}
                >
                  <LazyQRCodeCanvas value={url} size={200} />
                </Suspense>
              </Box>
              <Text variant="body" color={colors.grey600}>{t('orderDetail.payMeInstruction', { defaultValue: '使用 PayMe 應用程式掃描二維碼以授權付款' })}</Text>
            </VStack>
          </Box>
        </HStack>
        {_isMobileDevice && (
          <HStack gap="12px">
            <Text variant="body" color={colors.grey600} noWrap>
              {t('orderDetail.paymentLink', { defaultValue: '付款連結' })}
            </Text>
            <Button component="a" href={url} flex={1} borderRadius="30px" pl="30px" pr="30px" pt="5px" pb="5px" minHeight="40px" minWidth="200px" backgroundColor="#DB0011">
              <HStack gap="6px" alignItems="center">
                <Text variant="body" color={colors.white}>Pay with</Text>
                <PayMe style={{ color: colors.white, width: '21px', height: '28px' }} />
                <Text variant="body" color={colors.white}>PayMe</Text>
              </HStack>
            </Button>
          </HStack>
        )}
      </VStack>
    </Box>
  )
}
